import apiClient from './apiClient';

const getNotesByGuest = async (guestId, config) => {
    const response = await apiClient.get(`/guest_notes.php?action=getByGuest&guest_id=${guestId}`, config);
    return response.data;
};

const addNote = async (guestId, testo) => {
    const response = await apiClient.post('/guest_notes.php?action=add', { guest_id: guestId, testo });
    return response.data;
};

const updateNote = async (noteId, testo) => {
    const response = await apiClient.post('/guest_notes.php?action=update', { id: noteId, testo });
    return response.data;
};

const deleteNote = async (noteId) => {
    const response = await apiClient.delete(`/guest_notes.php?id=${noteId}`);
    return response.data;
};

export { getNotesByGuest, addNote, updateNote, deleteNote };
